import { render, staticRenderFns } from "./contest-info-page.html?vue&type=template&id=550eb7de&scoped=true&external"
import script from "./contest-info-page.js?vue&type=script&lang=js&external"
export * from "./contest-info-page.js?vue&type=script&lang=js&external"
import style0 from "./contest-info-page.scss?vue&type=style&index=0&id=550eb7de&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550eb7de",
  null
  
)

export default component.exports